import { render } from "./g-entity-modal.vue?vue&type=template&id=5403c54a&ts=true"
import script from "./g-entity-modal.vue?vue&type=script&lang=tsx"
export * from "./g-entity-modal.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__